var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-tooltip',{attrs:{"label":"Push prospect to Orion Astro","position":"is-bottom"}},[_c('b-button',{attrs:{"label":"Push to Astro","type":"is-info","size":"is-default","icon-pack":"fas","icon-left":"cloud-upload-alt","loading":_vm.in_progress,"outlined":""},on:{"click":function($event){return _vm.sendToOrionAstro()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }